<template>
	<div class="library">
		<div class="ss-breadcrumb">
			<div class="container-hts">
				<ul class="margin-0 p-0">
					<li>
						<router-link to="/thu-vien">Thư viện</router-link>
					</li>
                    <li><router-link to="/">Tiếng Việt</router-link></li>
                    <li><router-link to="/">Kết nối tri thức với cuộc sống</router-link></li>
                    <li><router-link to="/">Bài giảng điện tử</router-link></li>
                    <li><router-link to="/">Bài giảng</router-link></li>
				</ul>
			</div>
		</div>
		<div class="ss-data">
			<div class="container-hts">
				<div class="library__wrap display-flex justify-content-between">
					<div class="library__sidebar">
						<ul class="margin-0 p-0">
							<!-- <li v-for="(item,index) in subjects" :key="index" :class="{'active':  === item.practiceId}">
								<a href="javascript:;" @click="getPracticeBySubject(item)">{{ item.name }}</a>
							</li> -->
							<li >
                                <a href="javascript:;">Tất cả</a>
                            </li>
							<li data-toggle="collapse" href="#collapseSubject">
								<a href="javascript:;">TUẦN 1: TÔI VÀ CÁC BẠN</a>
							</li>
                            <div class="collapse" id="collapseSubject">
								<div class="collapse-subject">
									<ul class="subject-list">
                                        <li class="li-level-2">
                                            <a class="font-size-16 font-family-Semibold subject-cl" href="javascript:;">Bài 1: Tôi là học sinh lớp 1</a>
                                        </li>
                                        <li class="li-level-2">
                                            <a class="font-size-16 font-family-Semibold subject-cl" href="javascript:;">Bài 2: Đôi tai xấu xí</a>
                                        </li>
                                        <li class="li-level-2">
                                            <a class="font-size-16 font-family-Semibold subject-cl" href="javascript:;">Bài 3: Bạn của gió</a>
                                        </li>
                                        <li class="li-level-2">
                                            <a class="font-size-16 font-family-Semibold subject-cl" href="javascript:;">Bài 4: Giải thưởng tình bạn</a>
                                        </li>
                                        <li class="li-level-2">
                                            <a class="font-size-16 font-family-Semibold subject-cl" href="javascript:;">Bài 5: Sinh nhật của voi con</a>
                                        </li>
                                        <li class="li-level-2">
                                            <a class="font-size-16 font-family-Semibold subject-cl" href="javascript:;">Bài 6: Ôn tập</a>
                                        </li>
									</ul>
								</div>
							</div>
							<li>
								<a href="javascript:;">TUẦN 2: MÁI ẤM GIA ĐÌNH</a>
							</li>
							<li>
								<a href="javascript:;">TUẦN 3: MÁI TRƯỜNG MẾN YÊU</a>
							</li>
							<li>
								<a href="javascript:;">TUẦN 4: ĐIỀU EM CẦN BIẾT</a>
							</li>
							<li>
								<a href="javascript:;">TUẦN 5: BÀI HỌC TỪ CUỘC</a>
							</li>
                            <li>
								<a href="javascript:;">TUẦN 6: THIÊN NHIÊN KÌ THÚ</a>
							</li>
                            <li>
								<a href="javascript:;">TUẦN 7: THẾ GIỚI TRONG MẮT</a>
							</li>
                            <li>
								<a href="javascript:;">TUẦN 8: ĐẤT NƯỚC VÀ CON</a>
							</li>
                            <li>
								<a href="javascript:;">ÔN TẬP VÀ ĐÁNH GIÁ</a>
							</li>
						</ul>
						<div class="form-active">
							<p class="secondary_text_color font-size-16 font-family-Semibold">Kích hoạt mã cào sau mỗi cuốn sách giáo khoa để mở miễn phí học liệu điện tử và toàn bộ tính năng hỗ trợ</p>   
							<span class="primary-color font-size-16 font-sanpro-semibold cursor-pointer" v-b-modal.modal-active> Kích hoạt ngay</span>           
						</div>
						<modalActiveEbooks />
					</div>
					<div class="library__data">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-12">
                                <div class="form">
                                    <form class="form__search position-rel">
                                        <input   v-model.lazy="keyword" v-debounce="300" type="text" class="full-width font-size-15" placeholder="Tìm kiếm" required="required">
                                        <button type="submit" class="btn-search primary-color"><i class="fa fa-search secondary-color-blue"></i></button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="row list-book">
                            <div class="col-lg-4 col-md-4 col-12 item-lecture" v-for="(item, index) in getListLIbraryLessonPlan[0].listBookLessonPlans" :key="index">
                                <router-link to="/thu-vien/mon-hoc">
                                <img 	v-lazy="item.imageUrl != null && item.imageUrl != '' ? cdnUrl + item.imageUrl : thumbUrl('_ketnoitrithuc.png') "
								:alt="item.title"  />
                                        <div class="title-lecture">
                                            <h3 class="primary-color-txt font-size-16 font-sanpro-semibold">{{item.title}}</h3>
                                            <h4 class="secondary-color-txt font-size-14 font-family-Semibold">{{item.fileName}}</h4>
                                        </div>
                                </router-link>
                            </div>
                        </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import { STORE_KEY } from "../_store/constants";
    import { mapGetters, mapActions } from "vuex";
    import { APP_CONFIG } from "@/utils/constants";
    import debounce from "@/directives/debounce";
    import { classList, listExercise, getPracticeType, getListPracticeTypeBook, getLuggageNumber } from "./../_api/";
    import modalActiveEbooks from "../_components/modal/modalActiveEbooks"

	export default {
		name: "ViewLibrary",
		components: {
            modalActiveEbooks
        },
        directives: { debounce },
		data() {
			return {
                keyword:"",
                bookLessonPlanTypeId: this.$route.params.id,
				cdnUrl: APP_CONFIG.cdnurl,
				appUrl: APP_CONFIG.appUrl,
                listLecture:[
                    {
                        id: 1,
                        name: "Tiếng Việt 1 - Bài 2: Đôi tai xấu xí",
                        nameSmall: "Tiếng Việt 1 - Tập 1 - Kết nối tri thức"
                    },
                    {
                        id: 2,
                        name: "Tiếng Việt 1 - Bài 2: Đôi tai xấu xí",
                        nameSmall: "Tiếng Việt 1 - Tập 1 - Kết nối tri thức"
                    },
                    {
                        id: 3,
                        name: "Tiếng Việt 1 - Bài 2: Đôi tai xấu xí",
                        nameSmall: "Tiếng Việt 1 - Tập 1 - Kết nối tri thức"
                    },
                     {
                        id: 4,
                        name: "Tiếng Việt 1 - Bài 2: Đôi tai xấu xí",
                        nameSmall: "Tiếng Việt 1 - Tập 1 - Kết nối tri thức"
                    },
                    {
                        id: 5,
                        name: "Tiếng Việt 1 - Bài 2: Đôi tai xấu xí",
                        nameSmall: "Tiếng Việt 1 - Tập 1 - Kết nối tri thức"
                    },
                    {
                        id: 6,
                        name: "Tiếng Việt 1 - Bài 2: Đôi tai xấu xí",
                        nameSmall: "Tiếng Việt 1 - Tập 1 - Kết nối tri thức"
                    },
                     {
                        id: 7,
                        name: "Tiếng Việt 1 - Bài 2: Đôi tai xấu xí",
                        nameSmall: "Tiếng Việt 1 - Tập 1 - Kết nối tri thức"
                    },
                    {
                        id: 8,
                        name: "Tiếng Việt 1 - Bài 2: Đôi tai xấu xí",
                        nameSmall: "Tiếng Việt 1 - Tập 1 - Kết nối tri thức"
                    },
                    {
                        id: 9,
                        name: "Tiếng Việt 1 - Bài 2: Đôi tai xấu xí",
                        nameSmall: "Tiếng Việt 1 - Tập 1 - Kết nối tri thức"
                    },
                ],
			};
		},
		computed: {
			...mapGetters({
				practiceTypes: `${STORE_KEY}/practiceTypes`,
				exerciseClassCurr: `${STORE_KEY}/exerciseClassCurr`,
				practiceActive: `${STORE_KEY}/practiceActive`,
				getLibrabyFilterData:  `${STORE_KEY}/getLibrabyFilterData`,
				getPramLibrary: `${STORE_KEY}/getPramLibrary`,
				getListLIbraryLessonPlan: `${STORE_KEY}/getListLIbraryLessonPlan`,
			}),
			// routerQuery() {
			// 	return this.$router.history.current.query;
			// }
		},
		watch: {
            getPramLibrary: "getListLibrary",
              keyword: "changeKeyword",
        },
        mounted(){
           this.actionSetParamlibrary({ ...this.getPramLibrary, BookId: 0,BookIndexId:0,subjectId: 1,bookGroupId:0,classId:this.classActive,bookLessonPlanTypeId: this.bookLessonPlanTypeId});
        },
		created() {
			// this.getClassListFilter();
		},
		methods: {
			...mapActions("common", ["setLoading"]),
            ...mapActions(STORE_KEY, ['actionSetLocalExerciseClassCurr',"actionSetParamlibrary","actionlibraryListLessonPlan"]),
            changeKeyword(){
                  this.actionSetParamlibrary({ ...this.getPramLibrary, keyword:this.keyword });
            },
            getListLibrary(){
                // this.setLoading(true);
                this.actionlibraryListLessonPlan(this.getPramLibrary)
                .finally(() => {
                    this.setLoading(false);
                });
            },
    	 thumbUrl(filename) {
			return require(`@/assets/img/${filename}`);
		},
		}
	};
</script>

<style lang="scss" scoped>
	@import "./../../../assets/scss/variables";
    @import "./../../../assets/scss/mixins";
	@import "./../../../assets/scss/general";

  .collapse-subject{
    .subject-list{
      padding-left: 18px;
      margin-top: 6px;
    }
  }

	.library {
		&__sidebar {
			width: 27%;
			margin-right: 5%;
			ul {
				li {
					min-height: 36px;
					padding: 5px 18px;
					@extend .border-rd-8;
					margin-bottom: 2px;
					@extend .list-style-none;
					@extend .display-flex-center;
                    .subject-cl{
                        @extend .primary-color-txt;
                    }
					a {
						@extend .secondary-color-txt;
						@extend .font-size-16;
					}

					&.active, &:hover {
						background: $btn_hover_color;

						a {
							@extend .primary-color;
							@extend .font-sanpro-semibold;
						}
					}
                }
                .li-level-2{
                    &:hover{
                        background: #fff ;
                    }
                    a {
						@extend .secondary-color-txt;
						@extend .font-size-16;
					}
                }
            }
            .form-active{
                margin-top: 20px;
            }
		}

		&__data {
            width: 68%;
            .list-book{
                margin-top: 35px;
            }
            .item-lecture{
                margin-bottom: 40px;
                &:hover{
                    opacity: .8;
                }
            }
            .title-lecture{
                padding-left: 15px;
            }
		}

		&__tabs {
			&__content {
				padding: 35px 0 20px;
			}
        }
        .form{
            height: 30px;
            width: 100%;
            &__search{
                .btn-search{
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    z-index: 1;
                    background-color: transparent;
                    border: 0;
                    outline: 0;
                }
               input{
                    position: static;
                    height: 30px;
                    padding: 0 35px 0 12px;
                    top: 0;
                    left: 0;
                    border: 0;
                    outline: 0;
                    @extend .border-rd-20;
                    @extend .color_bg_gray_light;
                    @extend .primary-bg-color
               }
            }
        }

		@media screen and ( max-width: 991px ) {
			&__wrap {
				display: block;
			}

			&__sidebar, &__data {
				width: 100%;
			}
			&__sidebar {
				margin-bottom: 30px;
			}
		}
	}
</style>